
import useNetlifyLogin from '#/useNetlifyLogin'

import { defineComponent, ref, computed } from 'vue'
import { isEmpty } from 'ramda'
import { useRoute, useRouter } from 'vue-router'
import { isOK } from '@/modules/OkFail'
import { delay } from '@/modules/Geri'

import HermesLogo from '@/components/gui/HermesLogo.vue'
import Loader     from '@/components/gui/Loader.vue'
import TextInput  from '@/components/gui/TextInput.vue'

export default defineComponent({
	name: 'LoginForm',

	components: {
		HermesLogo,
		Loader,
		TextInput
	},

	setup (props, { emit }) {
		const { login, authorize, isAuthorized } = useNetlifyLogin()
		const { hash } = useRoute()
		
		const email     = ref<string>('')
		const password  = ref<string>('')
		const isValid   = computed<boolean>(() => !isEmpty(email.value) && !isEmpty(password.value))
		const isSuccess = ref<boolean>(false)
		const isError   = ref<boolean>(false)
		const isLoading = ref<boolean>(false)
		const message   = ref<string>('')

		async function onSubmit (): Promise<void> {
			isLoading.value = true
			isSuccess.value = false
			isError.value   = false
			message.value   = ''
			
			const load = await login(email.value, password.value)
			
			if (isOK(load)) {
				isSuccess.value = true
				message.value   = 'Innskráning tókst!'

				authorize(email.value)
				await delay(500)
			}
			else {
				isError.value = true
				message.value = load.data?.json?.error_description ?? '?!?'
			}
			emit('login', isAuthorized())
			isLoading.value = false
		}

		return { 
			email, 
			password, 
			isValid, 
			onSubmit,
			isSuccess,
			isError,
			isLoading,
			message
		}
	}
})
